import Handsontable from 'handsontable'

export default function () {
    //Handsontable.renderers.registerRenderer('name', renderer);
}


// WEBPACK FOOTER //
// ./App/components/Handsontable/renderers/register.js